/* eslint-disable no-template-curly-in-string */

import { CardFileUploaded, RadioCard, Typography } from 'components'
import { CardAlert } from 'components/cadFileUploaded/cardAlert'
import { DocumentsInputs, Icons, TypographyTypes } from 'interfaces'
import React from 'react'

interface StepTwoCsvTagProps {
	fileUploaded: boolean
	steps: string
	documentUpload: DocumentsInputs | undefined
	fileSize: number
	fileSizeUnit: string
}

export const StepTwoCsvTag: React.FC<StepTwoCsvTagProps> = ({
	fileUploaded,
	steps,
	documentUpload,
	fileSize,
	fileSizeUnit
}) => {
	return (
		<div className="flex flex-col justify-start w-full items-start gap-4">
			<Typography
				title={steps}
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>

			<RadioCard
				title="Use CSV's tags"
				description="For users who require individual tags, make sure the tag field is correctly filled out in the spreadsheet template."
				checked
				onChange={() => {
					return undefined
				}}
				id="radio-csv-tags"
				readOnly
			/>
			<Typography
				title="CSV files:"
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>
			{fileUploaded && (
				<>
					<CardFileUploaded
						nameFile={documentUpload?.name_file || ''}
						size={fileSize}
						unit={fileSizeUnit}
					/>
					<CardAlert
						title="Important!"
						description="Once finished, new users in the spreadsheet will be created in the platform, existing ones will be updated with the spreadsheet information."
						icon={Icons.assignmentInd}
					/>
				</>
			)}
		</div>
	)
}
